import Axios from "axios";
import jwtDecode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const JudgeHome = () => {
  const navigate = useNavigate();
  const [competitions, setCompetitions] = useState([]);

  const fetchJudgeCompi = () => {
    Axios.post(
      "https://ashish.moodi.org/multicity/get_judge_compi",
      {
        judge: jwtDecode(localStorage.getItem("judgeauthtoken")).judge.mcjId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        console.log(res.data);
        setCompetitions(res.data);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (localStorage.getItem("judgeauthtoken")) {
      fetchJudgeCompi();
    } else {
      navigate("/judge/login");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container">
      <h2>Select Competition To Judge</h2>
      <ul class="list-group">
        {competitions.map((competition) => {
          return (
            <a
              href={`/judge/multicity/competition/${competition.mcId}`}
              class="list-group-item list-group-item-action"
            >
              {competition.mcName}
            </a>
          );
        })}
      </ul>
    </div>
  );
};

export default JudgeHome;
